const BRANDS = ["Tata Communications", "Vedanta", "Alkem", "Siemens", "Deloitte", "PwC", "Accenture", "EY", "KPMG", "Capgemini", "Infosys", "TCS"];

const Clients = () => {
  const row = [...BRANDS, ...BRANDS];
  return (
    <section className="relative py-16 border-y border-slate-200 bg-[#F8FAFC] overflow-hidden" data-testid="clients-section">
      <p className="text-center font-mono2 text-[10px] sm:text-xs uppercase tracking-[0.3em] text-slate-500 mb-10 px-6">
        Alumni & engagement experience across leading enterprises
      </p>
      <div className="relative">
        <div className="absolute left-0 top-0 bottom-0 w-24 bg-gradient-to-r from-[#F8FAFC] to-transparent z-10" />
        <div className="absolute right-0 top-0 bottom-0 w-24 bg-gradient-to-l from-[#F8FAFC] to-transparent z-10" />
        <div className="marquee-track marquee-track-fast items-center gap-16 pr-16">
          {row.map((b, i) => (
            <span key={i} className="font-display text-xl sm:text-2xl font-bold tracking-tight text-slate-500 hover:text-amber-600 transition-colors duration-300 whitespace-nowrap">
              {b}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Clients;
